<template>
  <div class="parent">
    <Table ref="tableRef" :row-key="rowKey" :columns="columns" :loading="loading" :data="data" v-bind="$attrs" size="small" class="yclass" @on-row-click="_rowClick" @on-select="onSelect" @on-select-cancel="onSelectCancel" @on-selection-change="onSelectionChange" @on-select-all="onSelectAll" @on-select-all-cancel="onSelectAllCancel" @on-expand="onExpand">
      <template v-for="item in columns" #[item.slot]="param">
        <slot :name="item.slot" v-bind="param"></slot>
      </template>
      <template #footer v-if="hasFooter">
        <slot name="footer"></slot>
      </template>
    </Table>
    <div style="display: flex; justify-content: space-between; align-items: center">
      <div>
        <slot name="bottom-left"></slot>
      </div>
      <YPage v-if="showPageComponent" :model-value="pageObj.page" :total="pageObj.total" :page-size="pageObj.pageSize" :show-total="pageObj.showPageTotal" :show-elevator="pageObj.showPageElevator" @on-change="_changeCurrentPage" :showTotalPage="showTotalPage" />
    </div>
    <div v-if="!props.loading && props.data.length == 0 && showNoData" class="child" :style="{ height: !tableContent || tableContent <= 0 ? emptyDataHeight + 'px' : tableContent + 'px' }">
      <slot></slot>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, watch, nextTick } from 'vue'

const emit = defineEmits(['changeCurrentPage', 'on-selection-change', 'row-click', 'on-expand'])
const hasChecked = ref([])
let tableContent = ref(null)
const props = defineProps({
  columns: {
    type: Array,
    default: () => []
  },
  emptyDataHeight: {
    type: Number,
    default: 300
  },
  showNoData: {
    type: Boolean,
    default: true
  },
  data: {
    type: Array,
    default: []
  },
  showTotalPage: {
    type: Boolean,
    default: true
  },
  loading: {
    type: Boolean,
    default: false
  },
  pageObj: {
    type: Object,
    default: () => {
      return {
        page: 1,
        pageSize: 20,
        total: 0,
        showPageTotal: true,
        showPageElevator: true
      }
    }
  },
  rowKey: {
    type: [Boolean, String],
    default: false
  },
  showPageComponent: {
    type: Boolean,
    default: true
  },
  hasFooter: {
    type: Boolean,
    default: false
  }
})
watch(
  () => props.data,
  (newVal, oldVal) => {
    if (hasChecked.value.length > 0) {
      nextTick(() => {
        handleTableChecked()
      })
    }
  }
)
let tableRef = ref(null)
onMounted(() => {
  if (props.data.length === 0) {
    let height = tableRef.value.height
    tableContent.value = height - 35
  }
})
function onSelectionChange(val) {
  emit('on-selection-change', hasChecked.value)
}
function onExpand(row, status) {
  emit('on-expand', row, status)
}
function _rowClick(val, index) {
  emit('row-click', val, index)
}
function _changeCurrentPage(val) {
  emit('changeCurrentPage', val)
}

function onSelect(selection, row) {
  hasChecked.value.push(row)
}

function onSelectCancel(selection, row) {
  hasChecked.value.forEach((item, index) => {
    if (row.id === item.id) {
      hasChecked.value.splice(index, 1)
    }
  })
}

function onSelectAll(selection) {
  selection.forEach((item) => {
    hasChecked.value.push(item)
  })
  //去重
  hasChecked.value = hasChecked.value.filter((item, index) => hasChecked.value.findIndex((i) => i.id === item.id) === index)
}

/**
 * @param {*} selection 已选项数据
 * @description table取消全选时触发
 */
function onSelectAllCancel(selection) {
  props.data.forEach((item) => {
    // tempArr中找到该条数据并删除
    hasChecked.value.forEach((e, index) => {
      if (item.id === e.id) {
        hasChecked.value.splice(index, 1)
      }
    })
  })
}

/**
 * @param {*} datas 当前页数据
 * @description 还原有勾选的数据
 */
function handleTableChecked() {
  hasChecked.value.forEach((item) => {
    // 判断本页数据状态
    let index = props.data.findIndex((i) => i.id === item.id)
    if (index !== -1) {
      tableRef.value.objData[index]._isChecked = true
    }
  })
}
defineExpose({
  hasChecked,
  tableRef
  // handleTableChecked
})
</script>
<style lang="less" scoped>
.parent {
  position: relative;
  :deep(.ivu-spin-fix) {
    z-index: 300;
  }
  .yclass {
    :deep(.ivu-table-cell) {
      padding-left: 5px;
      padding-right: 5px;
    }
    :deep(.ivu-table-expanded-cell) {
      padding: 0;
    }
    :deep(td) {
      padding: 5px 0;
    }
  }
  .child {
    z-index: 30;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    background: white;
    top: 35px;
    width: 100%;
  }
}
</style>
